module.exports = __webpack_public_path__ + "static/media/Trirong-ExtraBoldItalic.0f979bda.ttf";